import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';

export const textParentCss = isCenterAligned =>
  css(typography.effra34, {
    fontWeight: fontWeights.regular,
    color: colorsPalette.grey,
    textAlign: isCenterAligned ? 'center' : 'left',
  });

export const containerPaddingCss = css({
  padding: '64px 0',
  [MediaQueries.mdAndUp]: {
    padding: '96px 0',
  },
});

export const containerMarginCss = css({
  margin: '64px 0',
  [MediaQueries.mdAndUp]: {
    margin: '96px 0',
  },
});
